import React, { useEffect, useState } from "react";
import SearchHeader from "../Reuseablecomponent/SearchHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  frameWorkTableDataStart,
  toolAction,
  toolTableDataStart,
} from "../../redux/actions/MasterActions";
import "./Users.scss";
import "./Master.scss";
import DeleteModal from "./Modals/DeleteModal";
import Pagination from "../Reuseablecomponent/Pagination";
import { privateRequest } from "../../api/apiConfig/privateRequest";
import MasterModal from "./Modals/MasterModal";
import { DeleteIcon, EditIcon } from "../../Icon";
import Loader from "../loader/Loader";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { statusToggleFunc } from "../../customHooks";
import Switch from "react-switch";
import { TOOLS_TABLE_DATA_START } from "../../redux/actionsTypes/Types";
import { DATA_NOT_FOUND } from "../../constant";

const Tool = () => {
  const [data, setData] = useState([]);
  const { tool, isDataFetch, pageCount, message } = useSelector(
    (state) => state.master["tool"]
  );
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isdeletemodal, setIsdeletemodal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const getSearchValue = (value) => {
    setSearchValue(value);
  };
  const openModal = (e, value) => {
    setIsOpen(true);
    setData(value);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const openDeleteModal = (id) => {
    setIsdeletemodal(true);
    setDeleteId(id);
  };
  const closeDeleteModal = () => {
    setIsdeletemodal(false);
    setDeleteId(null);
  };
  const handleActiveUser = async (value, id) => {
    statusToggleFunc("tool", id, setReload, value);
  };
  const deletePropsConfig = {
    closeDeleteModal,
    isdeletemodal,
    url: "tool",
    deleteId: deleteId,
    setReload,
  };
  const crudConfig = {
    title: "Tool",
    isOpen,
    closeModal,
    data,
    url: "tool",
    setReload,
  };
  const paginationProps = {
    setPageNo,
    pageSize,
    setPageSize,
    pageCount,
  };
  useEffect(() => {
    let payload = {};
    dispatch(
      toolAction(
        TOOLS_TABLE_DATA_START,
        (payload = { searchValue, pageNo, pageSize })
      )
    );
  }, [searchValue, pageNo, pageSize, reload]);

  return (
    <div>
      <SearchHeader
        title="Tool"
        openModal={openModal}
        getSearchValue={getSearchValue}
        setPageNo={setPageNo}
      />
      {isOpen && <MasterModal {...crudConfig} />}
      {isdeletemodal && <DeleteModal {...deletePropsConfig} />}
      <div className="usertab">
        <div className="users">
          <table className="users__table">
            <thead className="users__table--thead">
              <tr>
                <th>Tool</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="users__table--tbody">
              {isDataFetch ? (
                <tr>
                  <td colSpan={3}>
                    <Loader />
                  </td>
                </tr>
              ) : tool.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center", color: "red" }}>
                    {DATA_NOT_FOUND}
                  </td>
                </tr>
              ) : (
                tool.map((data) => (
                  <tr key={data.id}>
                    <td>{data.name}</td>
                    <td>
                      <Switch
                        size="xs"
                        onChange={(e) => handleActiveUser(e, data.id)}
                        checked={data.isActive}
                        onColor="#86d3ff"
                        onstyle="info"
                        onHandleColor="#2693e6"
                        handleDiameter={18}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 0px 2px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 0px 1px rgba(0, 0, 0, 0.2)"
                        height={15}
                        width={35}
                        id="material-switch"
                        className="react-switch"
                      />
                    </td>
                    <td>
                      <EditIcon openModal={openModal} data={data} />
                      <DeleteIcon
                        openDeleteModal={openDeleteModal}
                        data={data}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination {...paginationProps} />{" "}
    </div>
  );
};

export default Tool;
